// === SAA:UI:COVERAGE-OPTION-CARD ===
// Selectable coverage-option card used by the Personenauto Hoofddekking chooser.
// Top row: radio with the price badge immediately beside it. Below: the title on its
// own full-width line (wraps freely), then the description — so a long or wrapping
// title can never collide with the price.

import React from 'react';
import { coverageOptionCardStyles as s } from '../styles/commonStyles';

interface CoverageOptionCardProps {
  selected: boolean;
  label: string;
  description: string;
  /** Pre-formatted price text (e.g. "€85,61"); omitted/null hides the price row. */
  price?: string | null;
  onSelect: () => void;
  /** When true the card is dimmed and not selectable (e.g. the risk is declined for this coverage). */
  disabled?: boolean;
  /** Replaces the description when disabled, explaining why the option is unavailable. */
  disabledReason?: string;
}

export const CoverageOptionCard: React.FC<CoverageOptionCardProps> = ({
  selected,
  label,
  description,
  price,
  onSelect,
  disabled = false,
  disabledReason,
}) => (
  <div onClick={disabled ? undefined : onSelect} style={disabled ? s.cardDisabled : (selected ? s.cardSelected : s.card)}>
    <div style={s.topRow}>
      <div style={selected && !disabled ? s.radioSelected : s.radio}>
        {selected && !disabled && <div style={s.radioInner} />}
      </div>
      {!disabled && price && (
        <span style={{ ...s.price, ...(selected ? {} : s.priceDisabled) }}>{price}</span>
      )}
    </div>
    <span style={selected && !disabled ? s.label : s.labelInactive}>{label}</span>
    <p style={s.description}>{disabled && disabledReason ? disabledReason : description}</p>
  </div>
);
